export const AppConfig = {
  app: {
    name: import.meta.env.VITE_APP_NAME || "KNOWFLOW",
    version: import.meta.env.VITE_APP_VERSION || "0.1.0",
    environment: import.meta.env.VITE_APP_ENV || "development",
  },

  api: {
    useMock: import.meta.env.VITE_USE_MOCK === "true",
    cacheEnabled: import.meta.env.VITE_API_CACHE_ENABLED === "true",
    baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8787",
    timeout: Number.parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: Number.parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
  },

  features: {
    // debug: muestra warnings de reintentos de API y errores de cache en consola
    debug: import.meta.env.VITE_ENABLE_DEBUG === "true",
    // IA: si true, el chat solo busca en las categorías del usuario (o la categoría activa)
    aiRestrictToCategories: import.meta.env.VITE_AI_RESTRICT_TO_CATEGORIES !== "false",
    // Buscador global en la navbar
    globalSearch: import.meta.env.VITE_ENABLE_GLOBAL_SEARCH !== "false",
    // Toggle de búsqueda semántica IA en Knowledge
    aiSearch: import.meta.env.VITE_ENABLE_AI_SEARCH !== "false",
    // Conector de API externa con narración IA (categorías tipo "api")
    apiConnector: import.meta.env.VITE_ENABLE_API_CONNECTOR !== "false",
    // Subcategorías (un nivel dentro de cada categoría); apagado por defecto
    subcategories: import.meta.env.VITE_ENABLE_SUBCATEGORIES === "true",
  },

  // Ingreso: "local" (usuario y contraseña de KnowFlow) o "lcapii" (LCApii de Casa del
  // Audio). Tiene que coincidir con AUTH_PROVIDER del Worker.
  auth: {
    provider: import.meta.env.VITE_AUTH_PROVIDER || "local",
    lcapiiUrl: (import.meta.env.VITE_LCAPII_URL || "https://lcapii.casadelaudio.com").replace(/\/$/, ""),
    // Texto del botón: "Ingresar con {label}"
    label: import.meta.env.VITE_AUTH_LABEL || "Casa del Audio",
  },

  limits: {
    maxFileSize: Number.parseInt(import.meta.env.VITE_MAX_FILE_SIZE) || 26214400, // 25 MB
  },

  isDevelopment: () => AppConfig.app.environment === "development",
  isProduction: () => AppConfig.app.environment === "production",
};
